<ps-ui-header
  (closeSurvey)="goToDashboard()"
  (openServiceAccountModal)="selectBuyer($event)"
  (openMultiBuyerModal)="openMultiBuyerSelection()"
  [isRecontactSurvey]="true"
></ps-ui-header>
<ps-ui-recontact-survey
  [auth]="auth"
  (closeSurvey)="goToDashboard()"
></ps-ui-recontact-survey>
